import { Flex, useToasts } from '@applyboard/crystal-ui';
import { useNavigate } from 'react-router-dom';
import { formatErrorMessage } from '../../utils';
import { CreateProfileProps } from '../../clients';
import { NavBars } from '../../components/NavBars';
import { PageHeading } from '../../components/PageHeading';
import { ProfileForm } from '../../components/ProfileForm';
import { useProfile } from '../../hooks';
import { useCreateProfile } from '../../hooks/profile/useCreateProfile';
import { LoadingPage } from '../LoadingPage';

export function AddProfilePage(): JSX.Element {
  const { createProfile, isCreatingProfile } = useCreateProfile();
  const navigate = useNavigate();
  const toasts = useToasts();
  const { profileData: currentSessionUser, isGetProfileLoading: isGetCurrentSessionUserLoading } = useProfile();
  const currentSessionUserIsResolved = !isGetCurrentSessionUserLoading && currentSessionUser;

  if (!currentSessionUserIsResolved) {
    return <LoadingPage />;
  }

  const handleSubmit = (profileData: CreateProfileProps | Partial<CreateProfileProps>) => {
    // For creating new profiles, we should always receive complete data
    // Type guard to ensure we have all required fields
    if (
      !profileData.email ||
      !profileData.givenName ||
      !profileData.familyName ||
      !profileData.userType ||
      !profileData.apps
    ) {
      toasts.negative(formatErrorMessage(new Error('Missing required profile data')));
      return;
    }

    createProfile(profileData as CreateProfileProps, {
      onSuccess: () => {
        navigate('/profiles/school-users');
        toasts.positive('Success: Added user.');
      },
      onError: (error) => {
        const formattedError = formatErrorMessage(error);
        toasts.negative(formattedError);
      },
    });
  };

  return (
    <NavBars selectedMenuItem="Create User">
      <Flex p={{ xs: 4, sm: 12 }} direction="column">
        <PageHeading title="Add User" imageSrc="/user-management-icon.svg" imageAlt="add user icon" />
        <ProfileForm currentSessionUser={currentSessionUser} onSubmit={handleSubmit} isLoading={isCreatingProfile} />
      </Flex>
    </NavBars>
  );
}
